<template>
  <!-- 退款原因弹窗 -->
  <el-dialog
    :visible="reasonVisible"
    width="40%"
    custom-class="resonDialog"
    top="20vh"
    :before-close="cancelBut"
    append-to-body
  >
    <div class="el-dialog-body">
      <!-- 线下订单取消(等同于退款功能) -->
      <el-form v-if="dialogType === 'offline_cancel'">
        <el-form-item :label="$t('order.cancel_reasons')">
          <el-input
            v-model="remark"
            type="textarea"
            :placeholder="
              $t('setting.please_enter') + $t('order.cancel_reasons')
            "
            class="filter-item"
            style="width:80%;"
            clearable
            required
          />
        </el-form-item>
      </el-form>
      <!-- 审核订单 -->
      <el-form v-else-if="dialogType === 'examine'">
        <el-form-item label="是否审核通过">
          <el-radio-group v-model="examine_status">
            <el-radio label="1">确认通过</el-radio>
            <el-radio label="2">拒绝通过</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          :label="$t('order.examine_reasons')"
          :required="examine_status == '1' ? false : true"
        >
          <el-input
            v-model="remark"
            type="textarea"
            :placeholder="
              $t('setting.please_enter') + $t('order.examine_reasons')
            "
            class="filter-item"
            style="width:80%;"
            clearable
          />
        </el-form-item>
      </el-form>

      <!-- 添加备注 -->
      <el-form v-else-if="dialogType === 'addremark'">
        <el-form-item :label="$t('order.addremark')">
          <el-input
            v-model="remark"
            type="textarea"
            :placeholder="$t('setting.please_enter') + $t('order.remark')"
            class="filter-item"
            style="width:80%;"
            clearable
          />
        </el-form-item>
      </el-form>

      <!-- 新增其他费用 -->
      <el-form v-else-if="dialogType === 'additional'">
        <el-form-item :label="`其他费用`" />
        <!-- 有一个下拉框选择产品 product_id -->
        <el-form-item :label="`产品`">
          <el-select
            v-model="addData.product_id"
            :placeholder="`产品`"
            clearable
            style="width: 140px;"
            class="filter-item"
          >
            <el-option
              v-for="(item, index) in allproductList"
              :key=" index"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item :label="`数量`">
          <el-input
            v-model="addData.product_num"
            type="number"
            :placeholder="$t('setting.please_enter') + $t('order.Quantity')"
            class="filter-item"
            style="width:80%;"
            clearable
          />
        </el-form-item>
        <el-form-item :label="$t('royalGardens.enterOrder.label_remark')">
          <el-input
            v-model="addData.remarks"
            type="textarea"
            :placeholder="$t('setting.please_enter') + $t('order.remark')"
            class="filter-item"
            style="width:80%;"
            clearable
          />
        </el-form-item>
      </el-form>

      <!-- 确认到店 -->
      <el-form v-else-if="dialogType === 'confirmArrival'">
        {{ $t("order.AreYouSureConfirmArrival") }}?
      </el-form>

      <!-- 离店退房 -->
      <el-form v-else-if="dialogType === 'CheckOut'">
        <el-form-item :label="$t('order.remark')">
          <el-input
            v-model="remark"
            type="textarea"
            :placeholder="
              $t('setting.please_enter') +
                $t('order.CheckOut') +
                $t('order.remark')
            "
            class="filter-item"
            style="width:80%;"
            clearable
          />
        </el-form-item>
      </el-form>

      <div slot="footer" class="text-right">
        <el-button type="primary" @click="subremark">{{
          $t("setting.sure")
        }}</el-button>
        <el-button @click="cancelBut">{{ $t("order.cancel") }}</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'OfflineDialog',
  props: {
    reasonVisible: {
      type: Boolean,
      default: false
    },
    dialogType: {
      type: String,
      default: ''
    },
    allproductList: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      remark: '',
      examine_status: '1',
      addData: {}
    }
  },
  mounted() {
    console.log()
  },
  methods: {
    subremark() {
      if (this.examine_status == '2' && !this.remark) {
        this.$message({
          message: this.$t('setting.please_enter') + this.$t('order.remark'),
          type: 'error'
        })
        return
      }
      if (this.dialogType === 'additional' && !this.addData.product_id) {
        this.$message({
          message: '請選擇產品',
          type: 'error'
        })
        return
      }
      if (this.dialogType === 'additional' && !this.addData.product_num) {
        this.$message({
          message: '請輸入數量',
          type: 'error'
        })
        return
      }
      let query = {
        remark: this.remark,
        examine_status: this.examine_status,
        addData: this.addData
      }
      this.$emit('subremark', query)
      this.remark = ''
    },
    cancelBut() {
      this.$emit('cancelBut')
      this.remark = ''
    }
  }
}
</script>
